/* eslint-disable import/prefer-default-export */
import { isMessage, message, localizeSystemText } from './messages';

export function interfaceError(error, fallbackKey = 'common:errors.unexpected') {
  if (isMessage(error)) return error;
  const status = error && (error.status || error.statusCode);
  if (status === 401 || (error && error.code === 'UNAUTHORIZED')) return message('common:errors.unauthorized');
  if (status === 403 || (error && error.code === 'FORBIDDEN')) return message('common:errors.forbidden');
  const text = typeof error === 'string' ? error : error && error.message;
  // Resolve known application messages to descriptors; do not expose raw provider or server details.
  if (fallbackKey !== 'common:errors.unexpected' && ['Błąd zapisu', 'Save failed', 'Nie zapisano', 'Changes were not saved'].includes(text)) return message(fallbackKey);
  const translated = localizeSystemText(text, (key, params) => message(key, params));
  return isMessage(translated) ? translated : message(fallbackKey);
}
